import { render, staticRenderFns } from "./AppointDeliveryWarehouse.vue?vue&type=template&id=047dde84"
import script from "./AppointDeliveryWarehouse.vue?vue&type=script&lang=js"
export * from "./AppointDeliveryWarehouse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('047dde84')) {
      api.createRecord('047dde84', component.options)
    } else {
      api.reload('047dde84', component.options)
    }
    module.hot.accept("./AppointDeliveryWarehouse.vue?vue&type=template&id=047dde84", function () {
      api.rerender('047dde84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/csgOrder/source/components/AppointDelivery/AppointDeliveryWarehouse.vue"
export default component.exports